export default "__VITE_ASSET__CQXP0fgK__"